// Copyright (c) 2019 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {getVsrMessage, hasVsrErrorForClaimField, isResponsibleAccountEditable} from '../../../shared/services/claim-shared-helper';
import ClaimIncentiveProgram from '@deere/cps-it.warranty-model-factory/lib/claim-incentive-program';
import ClaimVsrMessage from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import ProgrameNameDropDown from '../../../shared/components/claim-fields/labeled-incentive-program-name-dropdown';

function handleProgramNameChange(event) {

    this.actions.updateSelectedProgramDropDown(event.target.value, this.programList);

}

function handleInputBlur(property, event) {

    this.actions.updateIncentiveClaimInputOnBlur(property, event.target.value);

}

const ProgamPanelContainer = props => {

    const canEditResponsibleAccount = isResponsibleAccountEditable(props.isEditable, props.claimStatus);

    return (
        <div className='program-panel'>
            <ProgrameNameDropDown
                className='program-name'
                errorMessage='PROGRAM_IS_REQUIRED'
                highlightClass={hasVsrErrorForClaimField(props.errors, 'programName', canEditResponsibleAccount)}
                isEditable={props.isEditable}
                isValid={props.isValid}
                label='PROGRAM'
                list={props.programList}
                onBlur={handleInputBlur.bind(props, 'programName')}
                onChange={props::handleProgramNameChange}
                selectedValue={props.selectedProgram}
                vsrMessage={getVsrMessage(props.errors, 'programName', props.isEditable)}
            />
        </div>);

};

ProgamPanelContainer.displayName = 'ProgamPanelContainer';
ProgamPanelContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    claimStatus: PropTypes.instanceOf(KeyValuePair).isRequired,
    errors: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)),
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    programList: PropTypes.arrayOf(PropTypes.instanceOf(ClaimIncentiveProgram)).isRequired,
    selectedProgram: PropTypes.instanceOf(ClaimIncentiveProgram).isRequired
};
export default ProgamPanelContainer;



// WEBPACK FOOTER //
// ./src/claim/incentive/components/program-name-panel/program-name-container.js